import React, { useState, useEffect } from 'react'
import articlesService from '../../../services/articles.service'
import { useEyeconxStore } from '../../../store/eyeconxStore'
import Loading from '../../common/Loading'

export default function ArticleView({ show, articleid, onClose }) {
    const clinicId = useEyeconxStore(state => state.user.clinicId)
    const [article, setArticle] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [articleNotFound, setArticleNotFound] = useState(false)

    useEffect(() => {
        if (articleid) getArticleById()
    }, [articleid])

    const getArticleById = () => {
        setIsLoading(true)
        articlesService
            .getArticleById(clinicId, articleid)
            .then(res => {
                setArticle(res.data)
                setIsLoading(false)
            })
            .catch(err => {
                setIsLoading(false)
                setArticleNotFound(true)
                console.log(err)
            })
    }

    return (
        <div
            className={`modal fade ${show ? 'show d-block' : ''}`}
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content rounded-3 shadow-lg">
                    <div className="modal-header">
                        <h5 className="modal-title fw-bold">
                            <i className="bi bi-journal-text me-2 text-primary"></i>
                            {article.title}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body article-modal-body">
                        {isLoading ? (
                            <Loading />
                        ) : articleNotFound ? (
                            <div className="text-center text-muted">
                                Article not found.
                            </div>
                        ) : (
                            <div
                                dangerouslySetInnerHTML={{ __html: article.content }}
                            />
                        )}
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={onClose}>
                            Close
                        </button>
                    </div>
                </div>
            </div>

            <style>{`
                .article-modal-body img {
                    max-width: 100%;
                    height: auto;
                    display: block;
                    margin: 10px auto;
                }
                .article-modal-body iframe {
                    max-width: 100%;
                }
                .article-modal-body p {
                    word-break: break-word;
                }
                .modal-body {
                    max-height: 70vh;
                    overflow-y: auto;
                }
            `}</style>
        </div>
    )
}
